import { ReactComponent as BookmarkIcon } from 'assets/icons/advert-bookmark.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { MouseEvent } from 'react';
import { toast } from 'sonner';

import { addBookmark, removeBookmark, selectBookmarks } from 'store/features/bookmarksSlice';
import { selectUser } from 'store/features/userSlice';
import {
    usePostApiV1ClientUserFavoritesAddToFavoriteByIdMutation,
    usePostApiV1ClientUserFavoritesRemoveFromFavoriteByIdMutation,
} from 'service/api/allApis';
import { cn } from 'lib/utils';

type Props = {
    advertId: number;
};
const AdvertBoomark = ({ advertId }: Props) => {
    const [mutateAddToFavorite] = usePostApiV1ClientUserFavoritesAddToFavoriteByIdMutation();
    const [mutateRemoveFromFavorite] =
        usePostApiV1ClientUserFavoritesRemoveFromFavoriteByIdMutation();
    const { bookmarks } = useSelector(selectBookmarks);
    const bookmarked = bookmarks.includes(advertId);
    const { user } = useSelector(selectUser);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    function toastOnSuccess() {
        toast.success(
            bookmarked ? t('success.removed-from-favorite') : t('success.added-to-favorite'),
        );
    }

    function toastOnError() {
        toast.error(bookmarked ? t('error.remove-from-favorite') : t('error.add-to-favorite'));
    }

    async function handleBookmarkClick(e: MouseEvent<SVGSVGElement, globalThis.MouseEvent>) {
        e.preventDefault();
        e.stopPropagation();
        dispatch(bookmarked ? removeBookmark(advertId) : addBookmark(advertId));
        if (!user) {
            toastOnSuccess();
            return;
        }
        const promise = bookmarked
            ? mutateRemoveFromFavorite({ id: advertId })
            : mutateAddToFavorite({ id: advertId });
        promise
            .unwrap()
            .then(() => {
                toastOnSuccess();
            })
            .catch(() => {
                toastOnError();
            });
    }

    return (
        <BookmarkIcon
            onClick={handleBookmarkClick}
            className={cn(
                'w-7 h-7 md:w-fit md:h-fit absolute right-[-1px] top-[-1px] cursor-pointer duration-200',
                bookmarked && 'fill-primary',
            )}
        />
    );
};

export default AdvertBoomark;
